import {
  createGlobalStyle,
  GlobalStyleComponent,
  DefaultTheme,
  ThemeProps,
} from "styled-components";

// import original module declarations

interface CustomTheme extends DefaultTheme {}

export const lightTheme: CustomTheme = {
  white: "#fff",
  backgroundDim: "#fcfcfc",
  primaryColor: "#4a7cf7",
  secondaryColor: "#0a6de6",
  linearGradient: "linear-gradient(145deg, #4a7cf7, #0a6de6 )",
  background: "#F6F6F6",
  foreground: "#FFFFFF",
  subtleBlack: "#C6CDD6",
  color: "#01102e",
  shadow: "0px 2px 2px 1px rgb(204 204 204)",
  subtleShadow: "0px 3px 10px -1px rgba(50, 50, 71, 0.1)",
  highShadow: "2px 3px 20px 1px #cccccccc",
  highBlueShadow: "2px 2px 25px 0px #4a7cf730",
  grey: "#979797",
  tint: "#33aa7a",
  fadeBg: "#88888855",
  subtleGrey: "#E8E8E8",
  black: "#000000",
  tableHighlight: "#ffffff",
  tableLowLight: "#E8E8E8",
  separator: "#ccc",
};

export const darkTheme: CustomTheme = {
  white: "#fff",
  primaryColor: "#4a7cf7",
  secondaryColor: "#054797",
  linearGradient: "linear-gradient(145deg, #4a7cf7, #0a6de6 )",
  background: "#09161a",
  backgroundDim: "#192830",
  // background: "#121212",
  // foreground: "#272822",
  foreground: "#152229",
  subtleBlack: "#121217",
  black: "#000000",
  grey: "#979797",
  subtleGrey: "#525252",
  color: "#cecfcf",
  tint: "#2e996e",
  fadeBg: "#00000080",
  tableHighlight: "#000000",
  tableLowLight: "#292a2b",
  subtleShadow: "1px 1px 10px 1px #131a1fec",
  highShadow: "0px 3px 15px -1px #101016cc",
  highBlueShadow: "2px 2px 17px 1px #0b1224cc",
  separator: "#393939",
};
export const GlobalStyle: GlobalStyleComponent<
  {},
  DefaultTheme
> = createGlobalStyle`
body {
 background:${(props) => props.theme.background}}
  *{
                transition: background 0.3s ease;
                transition-property: background, color;


    }
`;
